import React, { useState } from 'react'
import Mainlayout from '../layout/Mainlayout'
import Gamess from '../data/games.json'

export default function Allpeshbini() {
    const peshbini = JSON.parse(localStorage.getItem('peshbiniakan'));

    const [section, setSection] = useState(1);
    const navigation = [
        { name: "پێشبینیەکانی کۆمەڵەکان", num: 1 },
        { name: "پێشبینیەکانی قۆناغی ١٦", num: 2 },
        { name: "پێشبینیەکانی قۆناغی ٨", num: 3 },
        { name: "پێشبینیەکانی قۆناغی ٤", num: 4 },
        { name: "پێشبینیەکانی کۆتای", num: 5 }
    ]

    const groupspeshbini = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ناو
                            </th>


                        </tr>
                    </thead>
                    <tbody>

                        {peshbini ?
                            (

                                peshbini.map((peshbini) => {


                                    const game = Gamess[peshbini.id - 1]


                                    return (
                                        <>
                                            {

                                                peshbini.result === game.result ? (

                                                    <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                        <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                            {game.gametype === 'کۆمەڵەکان' ?
                                                                (
                                                                    1
                                                                ) :
                                                                (
                                                                    1
                                                                )
                                                            }
                                                        </th>
                                                        <td className=" md:p-5 p-2">
                                                            {game.result}
                                                        </td>
                                                        <td className=" md:p-5 p-2">
                                                            {peshbini.result}
                                                        </td>
                                                        <td className=" md:p-5 p-2">
                                                            {peshbini.gametype}
                                                        </td>
                                                        <th className=" md:p-5 p-2">
                                                            {peshbini.team1} - {peshbini.team2}
                                                        </th>
                                                        <th className=" md:p-5 p-2">
                                                            {peshbini.username}
                                                        </th>
                                                    </tr>

                                                )
                                                    : (

                                                        <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                            <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                {game.gametype === 'کۆمەڵەکان' ?
                                                                    (
                                                                        0
                                                                    )
                                                                    :
                                                                    (
                                                                        0
                                                                    )
                                                                }
                                                            </th>
                                                            <td className=" md:p-5 p-2">
                                                                {game.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.gametype}
                                                            </td>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.team1} - {peshbini.team2}
                                                            </th>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.username}
                                                            </th>
                                                        </tr>

                                                    )
                                            }
                                        </>
                                    )



                                })
                            )
                            :
                            (
                                null
                            )
                        }





                    </tbody>
                </table>
            </div>
        )
    }
    const shanzapeshbini = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ناو
                            </th>


                        </tr>
                    </thead>
                    <tbody>

                        {peshbini ?
                            (
                                peshbini.map((peshbini) => {


                                    const game = Gamess[peshbini.id - 1]

                                    if (peshbini.gametype === 'shanza') {

                                        return (
                                            <>
                                                {

                                                    peshbini.result === game.result ? (

                                                        <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                            <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                {game.gametype === 'shanza' ?
                                                                    (
                                                                        2
                                                                    ) :
                                                                    (
                                                                        2
                                                                    )
                                                                }
                                                            </th>
                                                            <td className=" md:p-5 p-2">
                                                                {game.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.gametype}
                                                            </td>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.team1} - {peshbini.team2}
                                                            </th>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.username}
                                                            </th>
                                                        </tr>

                                                    )
                                                        : (

                                                            <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                                <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                    {game.gametype === 'shanza' ?
                                                                        (
                                                                            0
                                                                        )
                                                                        :
                                                                        (
                                                                            0
                                                                        )
                                                                    }
                                                                </th>
                                                                <td className=" md:p-5 p-2">
                                                                    {game.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.gametype}
                                                                </td>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.team1} - {peshbini.team2}
                                                                </th>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.username}
                                                                </th>
                                                            </tr>

                                                        )
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        return null
                                    }



                                })
                            )
                            :
                            (
                                null
                            )

                        }





                    </tbody>
                </table>
            </div>
        )
    }
    const quaterpeshbini = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ناو
                            </th>


                        </tr>
                    </thead>
                    <tbody>

                        {peshbini ?
                            (
                                peshbini.map((peshbini) => {


                                    const game = Gamess[peshbini.id - 1]

                                    if (peshbini.gametype === 'quater') {

                                        return (
                                            <>
                                                {

                                                    peshbini.result === game.result ? (

                                                        <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                            <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                {game.gametype === 'quater' ?
                                                                    (
                                                                        2
                                                                    ) :
                                                                    (
                                                                        2
                                                                    )
                                                                }
                                                            </th>
                                                            <td className=" md:p-5 p-2">
                                                                {game.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.gametype}
                                                            </td>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.team1} - {peshbini.team2}
                                                            </th>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.username}
                                                            </th>
                                                        </tr>

                                                    )
                                                        : (

                                                            <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                                <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                    {game.gametype === 'quater' ?
                                                                        (
                                                                            0
                                                                        )
                                                                        :
                                                                        (
                                                                            0
                                                                        )
                                                                    }
                                                                </th>
                                                                <td className=" md:p-5 p-2">
                                                                    {game.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.gametype}
                                                                </td>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.team1} - {peshbini.team2}
                                                                </th>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.username}
                                                                </th>
                                                            </tr>

                                                        )
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        return null
                                    }



                                })
                            )
                            :
                            (
                                null
                            )

                        }





                    </tbody>
                </table>
            </div>
        )
    }
    const semipeshbini = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ناو
                            </th>


                        </tr>
                    </thead>
                    <tbody>

                        {peshbini ?
                            (
                                peshbini.map((peshbini) => {


                                    const game = Gamess[peshbini.id - 1]

                                    if (peshbini.gametype === 'semi') {

                                        return (
                                            <>
                                                {

                                                    peshbini.result === game.result ? (

                                                        <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                            <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                {game.gametype === 'semi' ?
                                                                    (
                                                                        2
                                                                    ) :
                                                                    (
                                                                        2
                                                                    )
                                                                }
                                                            </th>
                                                            <td className=" md:p-5 p-2">
                                                                {game.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.gametype}
                                                            </td>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.team1} - {peshbini.team2}
                                                            </th>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.username}
                                                            </th>
                                                        </tr>

                                                    )
                                                        : (

                                                            <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                                <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                    {game.gametype === 'semi' ?
                                                                        (
                                                                            0
                                                                        )
                                                                        :
                                                                        (
                                                                            0
                                                                        )
                                                                    }
                                                                </th>
                                                                <td className=" md:p-5 p-2">
                                                                    {game.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.gametype}
                                                                </td>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.team1} - {peshbini.team2}
                                                                </th>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.username}
                                                                </th>
                                                            </tr>

                                                        )
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        return null
                                    }



                                })
                            )
                            :
                            (
                                null
                            )

                        }





                    </tbody>
                </table>
            </div>
        )
    }
    const finalpeshbini = () => {
        return (
            <div className="my-4  md:my-0  w-fit md:w-4/5 overflow-x-auto shadow-md rounded-lg">
                <table className=" text-center w-full relative text-xs md:text-lg text-black bg-slate-100 ">
                    <thead className="md:text-lg text-chwaram uppercase bg-yakam ">
                        <tr>

                            <th scope="col" className=" md:p-5 p-2">
                                خاڵ
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ئەنجام
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                پێشبی
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                جۆری یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                یاری
                            </th>
                            <th scope="col" className=" md:p-5 p-2">
                                ناو
                            </th>


                        </tr>
                    </thead>
                    <tbody>

                        {peshbini ?
                            (
                                peshbini.map((peshbini) => {


                                    const game = Gamess[peshbini.id - 1]

                                    if (peshbini.gametype === 'final') {

                                        return (
                                            <>
                                                {

                                                    peshbini.result === game.result ? (

                                                        <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                            <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                {game.gametype === 'final' ?
                                                                    (
                                                                        2
                                                                    ) :
                                                                    (
                                                                        2
                                                                    )
                                                                }
                                                            </th>
                                                            <td className=" md:p-5 p-2">
                                                                {game.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.result}
                                                            </td>
                                                            <td className=" md:p-5 p-2">
                                                                {peshbini.gametype}
                                                            </td>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.team1} - {peshbini.team2}
                                                            </th>
                                                            <th className=" md:p-5 p-2">
                                                                {peshbini.username}
                                                            </th>
                                                        </tr>

                                                    )
                                                        : (

                                                            <tr className="bg-dwam divide-y-2 divide-yakam text-shasham border-black">
                                                                <th scope="row" className="text-center text-md uppercase md:p-1  p-2 font-medium  whitespace-nowrap">
                                                                    {game.gametype === 'final' ?
                                                                        (
                                                                            0
                                                                        )
                                                                        :
                                                                        (
                                                                            0
                                                                        )
                                                                    }
                                                                </th>
                                                                <td className=" md:p-5 p-2">
                                                                    {game.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.result}
                                                                </td>
                                                                <td className=" md:p-5 p-2">
                                                                    {peshbini.gametype}
                                                                </td>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.team1} - {peshbini.team2}
                                                                </th>
                                                                <th className=" md:p-5 p-2">
                                                                    {peshbini.username}
                                                                </th>
                                                            </tr>

                                                        )
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        return null
                                    }



                                })
                            )
                            :
                            (
                                null
                            )

                        }





                    </tbody>
                </table>
            </div>
        )
    }

    
    return (
        <Mainlayout>

            <div className='bg-dwam min-h-screen p-4 flex flex-col items-center space-y-3 j'>
                <div className='w-full md:w-[95%] text-[9px] h-fit md:text-lg items-center flex flex-row bg-yakam '>
                    {navigation.reverse().map((nav) => {
                        return (
                            <>
                                <div onClick={() => { setSection(nav.num) }} className='w-1/5 p-3 h-full cursor-pointer item-center text-center hover:bg-seyam hover:text-yakam text-chwaram'><p className=''>{nav.name}</p></div>
                            </>
                        )
                    })}
                </div>

                <div className=' w-full flex justify-center md:w-[95%]  '>
                    {
                        section === 1 ?
                            (
                                groupspeshbini()
                            )
                            :
                            section === 2 ?
                                (
                                    shanzapeshbini()
                                )
                                :
                                section === 3 ?
                                    (
                                        quaterpeshbini()
                                    )
                                    :
                                    section === 4 ?
                                        (
                                            semipeshbini()
                                        )
                                        :
                                        section === 5 ?
                                            (
                                                finalpeshbini()
                                            )
                                            :
                                            (
                                                null
                                            )
                    }
                </div>
            </div>
        </Mainlayout>
    )
}
